"use strict" ;

/**
 * Represents the smallest positive Single value greater than zero, <code>EPSILON=0.000000001</code>.
 * @name EPSILON
 * @memberof core.maths
 * @instance
 * @const
 */
const EPSILON = 0.000000001;

export default EPSILON;
